import {kSystemIcons} from "../../constants/icons";

export default function SystemKnowledgeExamplePictureError() {
    // Used in SystemQuestionPicture to display error
    // when fetching failed

    // BUILD
    return (
        <div className={`w-full flex flex-col space-y-[2px] justify-start items-center py-[8px] px-[16px] mt-[12px]`}>
            <i className={`material-icons text-[20px] text-greyLight7`}>
                {kSystemIcons.error}
            </i>
            <span className={"text-[16px] font-medium text-greyLight7 text-center"}>
                {"Une erreur est survenue lors de l'affichage de l'image"}
            </span>
        </div>
    );
}